var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"loading d-flex flex-row justify-content-center align-items-center"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }